import "./index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Route, Routes } from "react-router-dom";
import Homepage from "./pages/Homepage";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/NotFound";
import CarPage from "./pages/CarPage";
import RequestPage from "./pages/RequestPage";
import Header from "./components/Header";
import Footer from "./components/Footer";

import CookieConsent from "react-cookie-consent";
import RouteChangeReporter from "./components/RouteChangeReporter";
import useUTMTracker from "./functions/hooks/useUTMTracker";

const App = () => {
  useUTMTracker(); // calling it here so it doesn't matter which page is the landing page

  return (
    <>
      <Header />
      <ScrollToTop />
      <RouteChangeReporter />
      <ToastContainer />
      <Routes>
        {/* Homepage */}
        <Route path="/" element={<Homepage />} />

        {/* Car details page */}
        <Route path="/car/:id" element={<CarPage />} />

        {/* Car request page */}
        <Route path="/request/:id" element={<RequestPage />} />

        {/* 404 page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />

      <CookieConsent
        location="bottom"
        buttonText="Prihvaćam"
        declineButtonText="Odbijam"
        cookieName="myCookieConsent"
        style={{
          background: "#0074E8",
          fontSize: "13px",
        }}
        buttonStyle={{
          color: "#1D1D1B",
          fontSize: "13px",
          background: "#fff",
          padding: "12px 24px",
          margin: "8px",
        }}
        contentClasses="cookie-content-class"
        declineButtonStyle={{
          color: "#fff",
          background: "red",
          fontSize: "13px",
        }}
        expires={150}
        //new 11.9.2025.
        onAccept={() => {
          // gtag varijanta:
          if (window.gtag) {
            window.gtag("consent", "update", {
              ad_storage: "granted",
              analytics_storage: "granted",
              ad_user_data: "granted",
              ad_personalization: "granted",
            });
          }
          // GTM varijanta:
          if (window.dataLayer) {
            window.dataLayer.push({
              event: "consent_update",
              ad_storage: "granted",
              analytics_storage: "granted",
              ad_user_data: "granted",
              ad_personalization: "granted",
            });
          }
        }}
        onDecline={() => {
          // gtag varijanta:
          if (window.gtag) {
            window.gtag("consent", "update", {
              ad_storage: "denied",
              analytics_storage: "denied",
              ad_user_data: "denied",
              ad_personalization: "denied",
            });
          }
          // GTM varijanta:
          if (window.dataLayer) {
            window.dataLayer.push({
              event: "consent_update",
              ad_storage: "denied",
              analytics_storage: "denied",
              ad_user_data: "denied",
              ad_personalization: "denied",
            });
          }
        }}
      >
        Ova web stranica koristi kolačiće kako bi poboljšali korisničko
        iskustvo. Pročitajte našu{" "}
        <a
          href="https://www.peugeot.hr/korisne-informacije/politika-privatnosti.html"
          target="#"
          className="border-b border-b-white"
        >
          Politiku Privatnosti
        </a>{" "}
        ovdje.
      </CookieConsent>
    </>
  );
};

export default App;
